import React, { useEffect, useState, useRef } from 'react';
import { Box, useTheme, Typography } from '@mui/material';
import api from '../services/api';

function RotatingBelt() {
  const [messages, setMessages] = useState([]);
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef();
  const theme = useTheme();

  useEffect(() => {
    api.get('/api/cms/slider-config').then(res => {
      setMessages(res.data.beltMessages || []);
    });
  }, []);

  useEffect(() => {
    if (messages.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrent(c => (c + 1) % messages.length);
      }, 4000);
      return () => clearInterval(intervalRef.current);
    }
  }, [messages]);

  if (!messages.length) return null;
  const bg = theme.palette.mode === 'dark'
    ? 'linear-gradient(90deg, rgba(0,166,121,0.92), rgba(236,33,39,0.88))'
    : 'linear-gradient(90deg, #00a679 0%, #00c896 50%, #ec2127 100%)';
  const textColor = '#fff';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: '56px', md: '56px' },
        left: 0,
        right: 0,
        width: '100%',
        background: bg,
        color: textColor,
        py: { xs: 1.25, md: 1.5 },
        px: { xs: 2, md: 3 },
        fontWeight: 800,
        textAlign: 'center',
        overflow: 'hidden',
        minHeight: 48,
        letterSpacing: 1.3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 2,
        mb: 0,
        zIndex: 1100,
        borderBottom: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.04)' : '1px solid rgba(0,0,0,0.06)',
        transition: 'background 0.3s, color 0.3s',
      }}
      role="status"
      aria-live="polite"
    >
      <Typography
        component="span"
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          animation: 'slidein 1.2s',
          minWidth: 200,
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: { xs: '1rem', md: '1.25rem' },
          lineHeight: 1,
          textShadow: theme.palette.mode === 'dark' ? '0 1px 3px rgba(0,0,0,0.6)' : '0 1px 2px rgba(0,0,0,0.18)',
        }}
      >
        {messages[current]}
      </Typography>
      <style>{`
        @keyframes slidein {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
}

export default RotatingBelt;
